import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'pcln-design-system'
import { Content } from '@pcln/ace-content-react'

const StyledContent = ({ fallback, name }) => (
  <Text fontSize={12} fontWeight="bold" caps>
    <Content name={[name]} fallback={fallback} />
  </Text>
)

StyledContent.propTypes = {
  fallback: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default StyledContent
